// import lib
import { lazy } from "react";

const routes = [
  {
    role: "ROLE_FULLFILLMENT_CENTER",
    path: "/manage_order",
    element: lazy(() => import("../pages/Order/")),
  },
  {
    role: "ROLE_FULLFILLMENT_CENTER",
    path: "/fullfillment/orders",
    element: lazy(() => import("../pages/Fulfillmentcenter/orders")),
  },
  {
    role: "ROLE_FULLFILLMENT_CENTER",
    path: "/order_variants/:orderId",
    element: lazy(() => import("../pages/Order/OrderVariants")),
  },
  {
    role: "ROLE_FULLFILLMENT_CENTER",
    path: "/order_listing",
    element: lazy(() => import("../pages/Order/OrderListing")),
  },

  {
    path: "/Order/promoOrderItems/:orderItemId",
    element: lazy(() => import("../pages/Order/PromoOrderItems")),
  },
  {
    path: "/Order/editOrder/:orderItemId",
    element: lazy(() => import("../pages/Order/editOrder")),
  },
  {
    path: "/Order/createOrder",
    element: lazy(() => import("../pages/Order/createOrder")),
  },
  {
    path: "/Order/placeOrder",
    element: lazy(() => import("../pages/Order/PlaceOrder/placeOrder")),
  },

  {
    path: "/off_platform_orders",
    element: lazy(() => import("../pages/Order/Off-PlatformOrders")),
  },
  {
    path: "/instantOffSystemOrder",
    element: lazy(
      () =>
        import("../pages/Order/instantOffPlatformOrder/instantOffSystemOrder"),
    ),
  },
  {
    path: "/instantOffSystemOrder/:id",
    element: lazy(
      () =>
        import("../pages/Order/instantOffPlatformOrder/instantOffSystemOrder"),
    ),
  },
];

export default routes;
